import React, { Component, createRef } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    TextField,
    Typography,
    List,
    ListItem,
    ListItemText,
    IconButton,
    Divider,
    Card,
    CardContent,
    Box,
    InputAdornment,
    Tooltip,
    Chip
} from '@mui/material';
import {
    Add as AddIcon,
    Remove as RemoveIcon,
    Delete as DeleteIcon,
    Search as SearchIcon,
    ShoppingCart as CartIcon,
    ChatBubbleOutline as ObsIcon,
    Clear as ClearIcon
} from '@mui/icons-material';

class FrenteDeCaixaDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            busca: '',
            carrinho: {}
        };
        // Refs para controle de scroll das categorias
        this.categoriaRefs = {};
    }

    // Garante refs atualizadas para dynamic smooth scroll
    getOrCreateRef = (id) => {
        if (!this.categoriaRefs[id]) {
            this.categoriaRefs[id] = createRef();
        }
        return this.categoriaRefs[id];
    };

    scrollToCategoria = (catId) => {
        const ref = this.categoriaRefs[catId];
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    handleBuscaChange = (event) => {
        this.setState({ busca: event.target.value });
    };

    limparBusca = () => {
        this.setState({ busca: '' });
    };

    handleAdicionar = (produto) => {
        this.setState((prevState) => {
            const { carrinho } = prevState;
            const produtoNoCarrinho = carrinho[produto.produto_id];

            return {
                carrinho: {
                    ...carrinho,
                    [produto.produto_id]: {
                        ...produto,
                        quantidade: produtoNoCarrinho ? produtoNoCarrinho.quantidade + 1 : 1,
                        observacao: produtoNoCarrinho ? produtoNoCarrinho.observacao : ''
                    }
                }
            };
        });
    };

    handleDecrementar = (produtoId) => {
        this.setState((prevState) => {
            const { carrinho } = prevState;
            const produtoNoCarrinho = carrinho[produtoId];

            if (!produtoNoCarrinho) return null;

            const novoCarrinho = { ...carrinho };
            if (produtoNoCarrinho.quantidade > 1) {
                novoCarrinho[produtoId] = {
                    ...produtoNoCarrinho,
                    quantidade: produtoNoCarrinho.quantidade - 1
                };
            } else {
                delete novoCarrinho[produtoId];
            }

            return { carrinho: novoCarrinho };
        });
    };

    handleRemoverItem = (produtoId) => {
        this.setState((prevState) => {
            const novoCarrinho = { ...prevState.carrinho };
            delete novoCarrinho[produtoId];
            return { carrinho: novoCarrinho };
        });
    };

    handleObservacaoChange = (produtoId, texto) => {
        this.setState((prevState) => {
            const { carrinho } = prevState;
            if (!carrinho[produtoId]) return null;

            return {
                carrinho: {
                    ...carrinho,
                    [produtoId]: {
                        ...carrinho[produtoId],
                        observacao: texto
                    }
                }
            };
        });
    };

    limparCarrinho = () => {
        this.setState({ carrinho: {}, busca: '' });
    };

    calcularTotal = () => {
        const { carrinho } = this.state;
        return Object.values(carrinho).reduce(
            (acc, item) => acc + item.preco * item.quantidade,
            0
        );
    };

    render() {
        const { open, onClose, dadosCategorias } = this.props;
        const { busca, carrinho } = this.state;

        const itensCarrinho = Object.values(carrinho);
        const buscaMinusculo = busca.toLowerCase();

        const categoriasFiltradas = dadosCategorias
            .map((cat) => {
                const matchesCategoria = cat.categoria.toLowerCase().includes(buscaMinusculo);
                const produtosFiltrados = cat.produtos.filter(
                    (prod) =>
                        matchesCategoria ||
                        prod.nome.toLowerCase().includes(buscaMinusculo) ||
                        String(prod.cod).toLowerCase().includes(buscaMinusculo)
                );

                return { ...cat, produtos: produtosFiltrados };
            })
            .filter((cat) => cat.produtos.length > 0);

        return (
            <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', gap: 1, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
                    <CartIcon />
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
                        Frente de Caixa / PDV
                    </Typography>
                </DialogTitle>

                <DialogContent dividers sx={{ height: '75vh', p: 2, bgcolor: '#f4f6f8', overflow: 'hidden' }}>
                    <Box sx={{ display: 'flex', height: '100%', gap: 2 }}>

                        {/* COLUNA ESQUERDA: Busca, Atalhos de Categorias e Catálogo */}
                        <Box sx={{ flex: '1 1 55%', display: 'flex', flexDirection: 'column', height: '100%', minWidth: 0 }}>

                            {/* Campo de Busca Fixo */}
                            <TextField
                                fullWidth
                                autoFocus
                                placeholder="Buscar produto por nome, código ou categoria..."
                                variant="outlined"
                                value={busca}
                                onChange={this.handleBuscaChange}
                                size="small"
                                sx={{ bgcolor: 'background.paper', borderRadius: 1, mb: 1.5 }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon color="action" />
                                        </InputAdornment>
                                    ),
                                    endAdornment: busca && (
                                        <InputAdornment position="end">
                                            <IconButton size="small" onClick={this.limparBusca}>
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />

                            {/* Barra de Atalhos das Categorias (Scroll Horizontal) */}
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                overflowX: 'auto',
                                pb: 1,
                                mb: 1,
                                minHeight: '40px',
                                '&::-webkit-scrollbar': { height: 6 },
                                '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: 3 }
                            }}>
                                {dadosCategorias.map((cat) => (
                                    <Chip
                                        key={cat.id}
                                        label={cat.categoria}
                                        onClick={() => this.scrollToCategoria(cat.id)}
                                        color="primary"
                                        variant="outlined"
                                        clickable
                                        sx={{ fontWeight: 'bold', whiteSpace: 'nowrap', flexShrink: 0 }}
                                    />
                                ))}
                            </Box>

                            {/* Catálogo de Produtos com Scroll Próprio */}
                            <Box sx={{ flexGrow: 1, overflowY: 'auto', pr: 1 }}>
                                {categoriasFiltradas.length === 0 ? (
                                    <Box sx={{ p: 4, textAlign: 'center', bgcolor: 'background.paper', borderRadius: 2 }}>
                                        <Typography variant="body1" color="textSecondary">
                                            Nenhum produto cadastrado ou encontrado na busca.
                                        </Typography>
                                    </Box>
                                ) : (
                                    categoriasFiltradas.map((cat) => (
                                        <Box
                                            key={cat.id}
                                            ref={this.getOrCreateRef(cat.id)}
                                            sx={{ mb: 2.5, bgcolor: 'background.paper', p: 2, borderRadius: 2, boxShadow: '0px 1px 3px rgba(0,0,0,0.08)' }}
                                        >
                                            <Typography variant="subtitle1" sx={{ fontWeight: '800', color: 'primary.main', mb: 1, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                {cat.categoria}
                                            </Typography>
                                            <Divider sx={{ mb: 1 }} />

                                            <List disablePadding>
                                                {cat.produtos.map((prod) => {
                                                    const qtdNoCarrinho = carrinho[prod.produto_id]?.quantidade || 0;
                                                    return (
                                                        <ListItem
                                                            key={prod.produto_id}
                                                            secondaryAction={
                                                                <Button
                                                                    variant={qtdNoCarrinho > 0 ? "contained" : "outlined"}
                                                                    size="small"
                                                                    startIcon={<AddIcon />}
                                                                    onClick={() => this.handleAdicionar(prod)}
                                                                >
                                                                    Adicionar
                                                                </Button>
                                                            }
                                                            sx={{
                                                                borderRadius: 1,
                                                                mb: 0.5,
                                                                transition: '0.2s',
                                                                '&:hover': { backgroundColor: 'action.hover' },
                                                                borderLeft: qtdNoCarrinho > 0 ? '4px solid #1976d2' : '4px solid transparent'
                                                            }}
                                                        >
                                                            <ListItemText
                                                                primary={<Typography variant="body1" sx={{ fontWeight: 600 }}>{prod.nome}</Typography>}
                                                                secondary={`Cód: ${prod.cod} • R$ ${prod.preco.toFixed(2)}`}
                                                            />
                                                            {qtdNoCarrinho > 0 && (
                                                                <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: 'primary.main', borderRadius: 1, px: 1.5, py: 0.5, mr: 2 }}>
                                                                    <Typography variant="body2" sx={{ color: 'primary.contrastText', fontWeight: 'bold' }}>
                                                                        {qtdNoCarrinho}x
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                        </ListItem>
                                                    );
                                                })}
                                            </List>
                                        </Box>
                                    ))
                                )}
                            </Box>
                        </Box>

                        {/* COLUNA DIREITA: Carrinho Independente com Painel Fixo */}
                        <Box sx={{ flex: '1 1 45%', minWidth: 0 }}>
                            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', boxShadow: '0px 2px 4px rgba(0,0,0,0.08)' }}>

                                {/* Cabeçalho do Carrinho */}
                                <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'grey.50' }}>
                                    <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 'bold' }}>
                                        <CartIcon color="action" /> Resumo do Pedido ({itensCarrinho.reduce((a, b) => a + b.quantidade, 0)})
                                    </Typography>
                                </Box>

                                {/* Lista de Itens no Carrinho com Scroll Exclusivo */}
                                <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 2 }}>
                                    {itensCarrinho.length === 0 ? (
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'text.secondary', opacity: 0.5 }}>
                                            <CartIcon sx={{ fontSize: 64, mb: 1 }} />
                                            <Typography variant="body1" sx={{ fontWeight: 'medium' }}>Nenhum item selecionado</Typography>
                                            <Typography variant="caption">Clique em "Adicionar" no menu ao lado</Typography>
                                        </Box>
                                    ) : (
                                        <List disablePadding>
                                            {itensCarrinho.map((item) => (
                                                <Card key={item.produto_id} variant="outlined" sx={{ mb: 1.5, borderColor: 'divider' }}>
                                                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                                                        <Grid container alignItems="center" spacing={1}>
                                                            <Grid item size={{ xs: 7 }}>
                                                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'text.primary' }} noWrap>
                                                                    {item.nome}
                                                                </Typography>
                                                                <Typography variant="caption" color="textSecondary">
                                                                    Un: {item.preco.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} | Subtotal: <strong>{(item.preco * item.quantidade).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong>
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item size={{ xs: 5 }} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                                <IconButton size="small" onClick={() => this.handleDecrementar(item.produto_id)} color="primary" sx={{ border: '1px solid', borderColor: 'divider' }}>
                                                                    <RemoveIcon fontSize="small" />
                                                                </IconButton>

                                                                <Typography sx={{ mx: 1, minWidth: '20px', textAlign: 'center', fontWeight: 'bold' }}>
                                                                    {item.quantidade}
                                                                </Typography>

                                                                <IconButton size="small" onClick={() => this.handleAdicionar(item)} color="primary" sx={{ border: '1px solid', borderColor: 'divider' }}>
                                                                    <AddIcon fontSize="small" />
                                                                </IconButton>

                                                                <Tooltip title="Remover item">
                                                                    <IconButton size="small" onClick={() => this.handleRemoverItem(item.produto_id)} color="error" sx={{ ml: 0.5 }}>
                                                                        <DeleteIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>
                                                        </Grid>

                                                        {/* Campo de Observação */}
                                                        <Box sx={{ mt: 1 }}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                placeholder="Observação (Ex: Sem gelo, embalagem pra viagem)"
                                                                variant="standard"
                                                                value={item.observacao || ''}
                                                                onChange={(e) => this.handleObservacaoChange(item.produto_id, e.target.value)}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <ObsIcon sx={{ fontSize: 16, color: 'action.active' }} />
                                                                        </InputAdornment>
                                                                    ),
                                                                    style: { fontSize: 12 }
                                                                }}
                                                            />
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            ))}
                                        </List>
                                    )}
                                </Box>

                                {/* Bloco Fixo do Total (Rodapé do Carrinho) */}
                                <Box sx={{ p: 2, bgcolor: 'grey.100', borderTop: '1px solid', borderColor: 'divider' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>TOTAL GERAL:</Typography>
                                        <Typography variant="h4" color="success.main" sx={{ fontWeight: '800' }}>
                                            R$ {this.calcularTotal().toFixed(2)}
                                        </Typography>
                                    </Box>
                                </Box>

                            </Card>
                        </Box>

                    </Box>
                </DialogContent>

                {/* Rodapé Fixo de Ações */}
                <DialogActions sx={{ p: 2, bgcolor: 'background.paper', borderTop: '1px solid', borderColor: 'divider' }}>
                    <Button onClick={() => { this.limparCarrinho(); onClose(); }} color="inherit" variant="outlined">
                        Cancelar Venda
                    </Button>
                    <Button
                        onClick={() => {
                            this.props.onFinalizarVenda(this.state.carrinho, this.calcularTotal());
                            this.limparCarrinho();
                        }}
                        variant="contained"
                        color="success"
                        size="large"
                        disabled={itensCarrinho.length === 0}
                        sx={{ fontWeight: 'bold', px: 4 }}
                    >
                        Confirmar e Lançar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default FrenteDeCaixaDialog;